import * as dates from '@simplybenefits/sb-dates';
import validateInput from "../../../../services/FormValidation/validateInput.js";
import i18n from "../../../../localization/i18n.js";
import tokens from "../../../../localization/tokens.js";
import validateShares from './validateShares.js';

/**
 * 
 * @returns 
 */
const validateBeneficiaryForm = async ({
  firstname,
  lastname,
  shares,
  relationship,
  birthdate,
  type,
  trustee
}, beneficiaryShares, isContingent, beneficiaryID) => {
  const errors = {}; // Object to store validation errors

  errors.firstnameError = await validateInput('firstname', firstname);
  errors.lastnameError = await validateInput('lastname', lastname);
  errors.sharesError = await validateShares(beneficiaryShares, isContingent, shares, beneficiaryID);
  errors.type = await validateInput('checkEmpty', type);
  errors.birthdateError = await validateInput('birthdate', birthdate, i18n.locale);
  errors.relationshipError = await validateInput('relationship', relationship);

  // Check to see if the new Beneficiary is underage.
  const jsBirthdate = dates.getUTC(dates.formatOutgoingDate(birthdate));
  const age = Math.floor((dates.getUTC() - jsBirthdate) / (60 * 60 * 24 * 365));

  // If the birthday is underage and there is no Trustee we must show an error
  if (age < 18 && !trustee) {
    errors.birthdateError = i18n.t(tokens.labels.beneficiaries.beneficiaryUnderEighteenError);
  }

  // Check for any errors
  const hasErrors = Object.values(errors).some(Boolean);
  return hasErrors ? errors : false;
};
export default validateBeneficiaryForm;